// ═══════════════════════════════════════════════════════════
// Словник і форматування модуля задач — без React.
//
// Типи, результати й причини дублюються з api/_lib/tasks.js: CRA не дає
// імпортувати з-поза src/. Міняти треба обидва місця — на це є тест у
// tests/lint.
// ═══════════════════════════════════════════════════════════

export const STATUS_LABEL = {
  open: 'Нова', in_progress: 'В роботі', waiting: 'Очікує клієнта',
  done: 'Виконана', cancelled: 'Скасована',
};
export const PRIORITY_LABEL = { low: 'Низький', normal: 'Звичайний', high: 'Високий', urgent: 'Терміновий' };
export const TYPE_LABEL = {
  task: 'Завдання',
  client_contact: 'Контакт з клієнтом',
  sale: 'Продаж',
};

/** Результати свої на кожен тип — спільний список дозволяв закрити дзвінок
 *  як «Продано». */
export const OUTCOMES_BY_TYPE = {
  task:           ['done_ok', 'failed'],
  client_contact: ['agreed', 'refused', 'no_answer', 'call_back'],
  sale:           ['won', 'refused', 'postponed'],
};

export const OUTCOME_LABEL = {
  done_ok: 'Виконано',
  failed: 'Не вдалося',
  agreed: 'Домовились',
  refused: 'Відмова',
  no_answer: 'Не додзвонився',
  call_back: 'Передзвонити',
  won: 'Продано',
  postponed: 'Рішення перенесено',
  // Успадковані: досі трапляються в закритих задачах, у виборі не показуємо.
  lost: 'Відмова',
  not_relevant: 'Не актуально',
};

/** Причини перенесення дедлайну. Той самий набір, що на сервері. */
export const RESCHEDULE_REASONS = [
  { id: 'waiting_colleague', name: 'Чекаю дані від колеги' },
  { id: 'more_urgent',       name: 'Зʼявилися терміновіші справи' },
  { id: 'underestimated',    name: 'Недооцінив обсяг' },
  { id: 'blocked_outside',   name: 'Заблоковано зовні' },
  { id: 'client_moved',      name: 'Клієнт переніс' },
];

export const CANCEL_REASONS = [
  { id: 'client_refused', name: 'Клієнт відмовився' },
  { id: 'not_relevant',   name: 'Уже не актуально' },
  { id: 'duplicate',      name: 'Дублікат' },
  { id: 'created_wrong',  name: 'Створено помилково' },
  { id: 'solved_other',   name: 'Вирішено іншим шляхом' },
];

/** Повторюваність. Той самий набір, що на сервері. */
export const RECURRENCE_LABEL = {
  daily: 'Щодня', weekly: 'Щотижня', monthly: 'Щомісяця', quarterly: 'Щокварталу',
};

/** Причини відмови. Список, а не вільний текст: по «дорого / задорого /
 *  ціна» нічого не згрупуєш. Поки з коду — редактор буде пізніше. */
export const LOSS_REASONS = [
  { id: 'price', name: 'Дорого' },
  { id: 'no_time', name: 'Немає часу' },
  { id: 'competitor', name: 'Пішов до конкурента' },
  { id: 'not_now', name: 'Не актуально' },
  { id: 'changed_mind', name: 'Передумав' },
  { id: 'no_contact', name: 'Немає контакту' },
];

export const OPEN_STATUSES = ['open', 'in_progress', 'waiting'];
export const isOpenStatus = (s) => OPEN_STATUSES.includes(s);

export const DAY = 86400000;
export const pad = (n) => String(n).padStart(2, '0');
export const startOfDay = (ts) => { const d = new Date(ts); d.setHours(0, 0, 0, 0); return d.getTime(); };
export const toDateInput = (ts) => {
  const d = new Date(ts);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export function fmtDue(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  const today = startOfDay(Date.now());
  const day = startOfDay(ts);
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  if (day === today) return `сьогодні ${time}`;
  if (day === today + DAY) return `завтра ${time}`;
  if (day === today - DAY) return `вчора ${time}`;
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${time}`;
}

export function fmtWhen(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Прострочене / Сьогодні / Завтра / Пізніше / Без дедлайну — в цьому порядку. */
export function groupByDue(items) {
  const today = startOfDay(Date.now());
  const buckets = [
    { key: 'overdue', label: 'Прострочені', items: [] },
    { key: 'today', label: 'Сьогодні', items: [] },
    { key: 'tomorrow', label: 'Завтра', items: [] },
    { key: 'later', label: 'Пізніше', items: [] },
    { key: 'none', label: 'Без дедлайну', items: [] },
  ];
  const by = Object.fromEntries(buckets.map(b => [b.key, b]));
  for (const t of items) {
    if (!t.dueAt) { by.none.items.push(t); continue; }
    if (t.isOverdue) { by.overdue.items.push(t); continue; }
    const day = startOfDay(t.dueAt);
    if (day === today) by.today.items.push(t);
    else if (day === today + DAY) by.tomorrow.items.push(t);
    else by.later.items.push(t);
  }
  return buckets.filter(b => b.items.length);
}
